module.exports = [{"data":"averageBunchWeight","title":"Average Bunch Weight (kg/p/yr)"},{"data":"numberOfBunches","title":"Bunch Number (no./p/yr)"},{"data":"freshFruitBunch","title":"Fresh Fruit Bunch (kg/p/yr)"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/yield-derived-variable.json
// module id = JGty
// module chunks = 102